module.exports = __webpack_public_path__ + "static/media/logo-footer-powered.7ebe779d.svg";